export const ERROR_MESSAGE = 'Campo obrigatório não preenchido'
export const ERROR_MESSAGE_NUMBERS_IN_STRING = 'Campo não aceita números'
export const ERROR_MESSAGE_STRING_IN_NUMBERS = 'Campo não aceita letras'
export const ERROR_MESSAGE_INVALID_NAME = 'Nome inválido'
export const ERROR_MESSAGE_DATE_INCORRECT = 'Data do fato maior do que data de apreensão'
export const ERROR_MESSAGE_EMAIL_INCORRECT = 'Email inválido'
export const ERROR_MESSAGE_CPF_INCORRECT = 'CPF inválido'
export const ERROR_MESSAGE_CNJ_INCORRECT = 'Número CNJ inválido'

export type ErrorType = {
  errors?: string[]
  message: string
}

export const errorInit: ErrorType = {
  errors: [],
  message: '',
}
